// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__mJhqy","row":"Node_row__24ZMU","label":"Node_label__1PwEF","footer":"Node_footer__2MRJb"};